import {
  Component,
  Inject,
  OnInit,
  Renderer2,
  ViewEncapsulation,
  AfterViewInit,
  HostListener
} from '@angular/core';
import { GlobalConstants } from 'src/app/common/global-constants';
import IMenu from 'src/app/models/menu';
import {DomSanitizer, SafeHtml} from '@angular/platform-browser';
import { DOCUMENT } from '@angular/common';
import { WebServiceService } from 'src/app/services/web-service.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  encapsulation: ViewEncapsulation.None,
  host: {
    class: 'app-footer'
  }
})
export class FooterComponent implements OnInit, AfterViewInit {
  bottom_menu:IMenu|undefined;
  main_menu:IMenu|undefined;
  layout_text: any;
  activeIndex:number = -1;
  currentYear: number;
  public lang: string = GlobalConstants.lang;
  isTablet: boolean = false;
  
  constructor(
    public sanitizer: DomSanitizer,
    private renderer: Renderer2,
    public webservice: WebServiceService,
    @Inject(DOCUMENT) private document: HTMLDocument
  ) {
    this.bottom_menu = GlobalConstants.layout.footer.find(t=> t.slug == "bottom");
    this.main_menu = GlobalConstants.layout.footer.find(t=> t.slug == "menu");
    this.layout_text = GlobalConstants.layout.layout_text;
  }

  @HostListener('window:resize', ['$event'])
  onResize() {
    this.checkViewport();
  }

  ngOnInit(): void {
    this.currentYear = new Date().getFullYear();
    this.checkViewport();
  }
  
  checkViewport() {
    this.isTablet = window.innerWidth < 992 && window.innerWidth >= 768;
  }
  
  ngAfterViewInit(): void {
    setTimeout(() => {
      this.loadLinkedInScript();
    }, 1000);
  }
  
  loadLinkedInScript(): void {
    const linkedinContainer = this.document.getElementsByClassName("linkedinContainer")[0];
    if (!linkedinContainer) return;
    
    this.renderer.setStyle(linkedinContainer, 'min-height', '28px');
    
    const script = this.renderer.createElement("script");
    script.type = "IN/FollowCompany";
    this.renderer.setAttribute(script, 'data-id', '236475');
    this.renderer.setAttribute(script, 'data-counter', 'right');
    linkedinContainer.appendChild(script);
  }

  goLink($event:any, url:string, name?:string, category?:string){
    if (!url || !url.trim()) {
      $event.preventDefault();
      return;
    }
    
    $event.preventDefault();
    
    const buttonName = name || url;
    
    const specialButtons = ['Bize Ulaşın', 'Hizmet Noktalarımız', 'Sıkça Sorulan Sorular', 
                           'Contact Us', 'Service Points', 'Frequently Asked Questions'];
                           
    if (specialButtons.includes(buttonName)) {
      this.webservice.dataLayerFooterMenuClick(buttonName);
    } else {
      this.webservice.dataLayerFooterMenuClick(buttonName, category);
    }
    
    this.webservice.dataLayerEvent('Click Event', 'Footer-Two', url, false, 'gaEvent');
    
    setTimeout(function(){ window.location.assign(url);}, 100);
    return;
  }
  onMenuClick(event: MouseEvent, i: number, menu: any) {
    if (window.innerWidth <= 991) {
      event.preventDefault();
      this.activeIndex = this.activeIndex === i ? -1 : i;
    } else {
      if (menu.url && menu.url.trim()) {
        this.goLink(event, menu.url, menu.title, 'Alt Menü');
      } else {
        event.preventDefault();
      }
    }
  }
}
